import { render, staticRenderFns } from "./pageGraphicNav.vue?vue&type=template&id=2fbb5545"
import script from "./pageGraphicNav.vue?vue&type=script&lang=js"
export * from "./pageGraphicNav.vue?vue&type=script&lang=js"
import style0 from "./pageGraphicNav.vue?vue&type=style&index=0&id=2fbb5545&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports